define [], () ->
  ($resource, RENTAPPLICATION_API_URL) ->
    $resource(
      "#{RENTAPPLICATION_API_URL}/api/v1/applicant/:id/",
      {},
      {
        get:
          cache: true
        update:
          url: "#{RENTAPPLICATION_API_URL}/api/v1/applicant/:id/"
          method: 'PATCH'
          params:
            id: "@id"
      }
    )



// WEBPACK FOOTER //
// ./resources/Applicant.coffee